<template>
  <div id="app">
    <Navbar v-if="windowWidth > 1000" />
    <MobileNav v-else />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <Footer />
  </div>
</template>
<script>
import Navbar from "@/components/Navbar";
import MobileNav from "@/components/MobileNav";
import Footer from "@/components/BaseFooter";
export default {
  components: {
    Navbar,
    Footer,
    MobileNav,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
};
</script>
<style lang="scss">
.list-enter,
.list-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.button {
  border-top-left-radius: 6px !important;
  border-top-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 6px !important;
}
.input {
  border: none !important;
  border-radius: 0 !important;
  border-bottom: 1px solid #494949 !important;
}
#app {
  font-family: "Nunito Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: ghostwhite;
  background: #111;
}
.va {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* total width */
::-webkit-scrollbar {
  background-color: transparent;
  width: 16px;
}

/* background of the scrollbar except button or resizer */
::-webkit-scrollbar-track {
  background-color: #111;

  &:hover {
    background-color: #111;
  }
}

/* scrollbar itself */
::-webkit-scrollbar-thumb {
  background-color: #bf9c5a;
  border-radius: 16px;
  border: 5px solid #111;
  &:hover {
    background-color: #bf9c5a;
    border: 4px solid #111;
  }
}

/* set button(top and bottom of the scrollbar) */
::-webkit-scrollbar-button {
  display: none;
}

/* div box */
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #bf9c5a;

    &.router-link-exact-active {
      color: #bf9c5a;
    }
  }
}
.hero-body {
  text-align: center;
}
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #01010c;
$primary-invert: findColorInvert($primary);
$secondary: rgb(129, 102, 50);
$secondary-invert: findColorInvert($secondary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
$input-background-color: #0d0c10;
$input-border-color: #494949;
$input-focus-box-shadow-color: #494949;
$input-color: ghostwhite;
$loading-background: #0d0c10;
// Overrides
$navbar-background-color: transparent;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "light": (
    $light,
    $light-invert,
  ),
  "dark": (
    $dark,
    $dark-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "secondary": (
    $secondary,
    $secondary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
  "twitter": (
    $twitter,
    $twitter-invert,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.25s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
